import { render, staticRenderFns } from "./activityData.vue?vue&type=template&id=6b2f4d90&scoped=true"
import script from "./activityData.vue?vue&type=script&lang=js"
export * from "./activityData.vue?vue&type=script&lang=js"
import style0 from "./activityData.vue?vue&type=style&index=0&id=6b2f4d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f4d90",
  null
  
)

export default component.exports